import React from 'react';

function plus() {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10.9973"
        cy="11.345"
        r="10.4085"
        fill="#F7F8FB"
        stroke="#E4E7EC"
        strokeWidth="1.09563"
      />
      <path
        d="M10.2691 16.1506V5.31418H11.7328V16.1506H10.2691ZM5.57845 11.46V10.0048H16.4235V11.46H5.57845Z"
        fill="#A0B1BA"
      />
      <path
        d="M10.2691 16.1506H9.17348V17.2463H10.2691V16.1506ZM10.2691 5.31418V4.21855H9.17348V5.31418H10.2691ZM11.7328 5.31418H12.8284V4.21855H11.7328V5.31418ZM11.7328 16.1506V17.2463H12.8284V16.1506H11.7328ZM5.57845 11.46H4.48282V12.5556H5.57845V11.46ZM5.57845 10.0048V8.90921H4.48282V10.0048H5.57845ZM16.4235 10.0048H17.5191V8.90921H16.4235V10.0048ZM16.4235 11.46V12.5556H17.5191V11.46H16.4235ZM11.3647 16.1506V5.31418H9.17348V16.1506H11.3647ZM10.2691 6.4098H11.7328V4.21855H10.2691V6.4098ZM10.6372 5.31418V16.1506H12.8284V5.31418H10.6372ZM11.7328 15.055H10.2691V17.2463H11.7328V15.055ZM6.67408 11.46V10.0048H4.48282V11.46H6.67408ZM5.57845 11.1005H16.4235V8.90921H5.57845V11.1005ZM15.3278 10.0048V11.46H17.5191V10.0048H15.3278ZM16.4235 10.3643H5.57845V12.5556H16.4235V10.3643Z"
        fill="#E4E7EC"
      />
    </svg>
  );
}

export default plus;
